const jarallax = require('./src/jarallax.esm').default;
const jarallaxVideo = require('./src/jarallax-video.esm').default;
const jarallaxElement = require('./src/jarallax-element.esm').default;

module.exports = {
    jarallax,
    jarallaxElement() {
        return jarallaxElement(jarallax);
    },
    jarallaxVideo() {
        return jarallaxVideo(jarallax);
    },
};



//////////////////
// WEBPACK FOOTER
// /Users/valentinocossar/Projects/cappellotto-new.com/app/public/wp-content/themes/cappellotto/node_modules/jarallax/index.js
// module id = 22
// module chunks = 0